import { render } from "./EditLocationModal.vue?vue&type=template&id=1071d404&scoped=true"
import script from "./EditLocationModal.vue?vue&type=script&lang=js"
export * from "./EditLocationModal.vue?vue&type=script&lang=js"

import "./EditLocationModal.vue?vue&type=style&index=0&id=1071d404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1071d404"]])

export default __exports__